/* unplugin-vue-components disabled */import script from "./triggered-ad.vue?vue&type=script&lang=js"
export * from "./triggered-ad.vue?vue&type=script&lang=js"

import "./triggered-ad.vue?vue&type=style&index=0&id=2bec73a7&lang=scss"

const __exports__ = script;

export default __exports__